import { createContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { Outlet } from "react-router";
import type { Workflow } from "@butler/shared";
import { api } from "@/api";
import { toast } from "sonner";

export const WorkflowContext = createContext<Workflow | null>(null);

export const WorkflowProvider = () => {
  const { id } = useParams();
  const [workflow, setWorkflow] = useState<Workflow | null>(null);

  useEffect(() => {
    const fetchWorkflow = async () => {
      if (!id) {
        toast.error("No ID provided");
        return;
      }
      const toastId = toast.loading("Loading workflow...");
      api
        .workflow({ id })
        .get()
        .then(({ data, error }) => {
          if (error) {
            console.error(error);
            setWorkflow(null);
            return;
          }
          if (!data) {
            console.error("Workflow data is undefined");
            setWorkflow(null);
            return;
          }
          setWorkflow(data);
        });
      toast.dismiss(toastId);
    };
    fetchWorkflow();
  }, [id]);

  return (
    <WorkflowContext.Provider value={workflow}>
      <Outlet />
    </WorkflowContext.Provider>
  );
};
